import React, { useEffect, useRef, useState } from "react";
import { FaCopy } from "react-icons/fa";
import { FaCheckCircle } from "react-icons/fa";
import axios from "axios";
import moment from "moment/moment";
import Loader from "../componets/Loader";

const Gift = () => {
    const [giftCodes, setGiftCodes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalData, setModalData] = useState({ show: false, code: "" });

    const fetchGiftCodes = async () => {
        try {
            const response = await axios.get(
                "https://api.55clubregister.com/api/v1/I4gsv24w1/rest_api/get_gift.php"
            );
            if (response.data && response.data.status === "1") {
                setGiftCodes(response.data.data);
            } else {
                setGiftCodes([]);
            }
        } catch (error) {
            console.error("Error fetching gift codes:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchGiftCodes();
    }, []);

    const handleCopy = (code) => {
        navigator.clipboard.writeText(code); // Copy to clipboard
        setModalData({ show: true, code });
    };

    if (loading) return <Loader />;

    return (
        <div className="min-h-screen bg-gray-100 flex flex-col items-center py-8 paddingX">
            <h1 className="text-2xl font-bold mb-6">Gift Codes</h1>
            <div className="flex flex-col gap-4 w-full max-w-lg">
                {
                    giftCodes.length > 0 ? (
                        <>
                            {giftCodes.map((item) => (
                                <div
                                    key={item.id}
                                    className="relative bg-white border border-orange-400 rounded-lg p-4 shadow-md flex justify-between items-center"
                                >
                                    <div className="space-y-2 w-full">
                                        <p className="text-sm font-semibold text-gray-600">GIFT CODE:</p>
                                        <p className="text-[0.9rem] xxs:text-[1.11] sm:text-lg font-bold text-gray-800 break-words whitespace-normal w-1/2 ssm:w-[60%] xxs:w-full">
                                            {item.gift_code}
                                        </p>
                                        <p className="text-sm text-gray-500">
                                            {moment(item.create_date).format("YYYY-MM-DD")}
                                        </p>
                                    </div>
                                    <button
                                        className="text-orange-500 p-2 rounded-full hover:bg-orange-100 absolute ssm:relative bottom-2 right-2"
                                        onClick={() => handleCopy(item.gift_code)}
                                    >
                                        <FaCopy size={24} />
                                    </button>
                                </div>
                            ))}
                        </>
                    ) : (
                        <>
                            <div className="bg-white border border-gray-300 rounded-lg p-6 shadow-md text-center">
                                <p className="text-lg font-semibold text-gray-700">No gift codes found</p>
                                <p className="text-sm text-gray-500 mt-2">
                                    Please check back later for new gift codes.
                                </p>
                            </div>
                        </>
                    )
                }


            </div>

            {/* Modal */}
            {modalData.show && (
                <GiftCodeModal
                    gift_code={modalData.code}
                    onClose={() => setModalData({ ...modalData, show: false })}
                />
            )}
        </div>
    );
};

export default Gift;

const GiftCodeModal = ({ gift_code, onClose }) => {
    const modalRef = useRef();

    const handleOutsideClick = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            onClose();
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="bg-white rounded-lg shadow-lg p-6 max-w-sm w-[90%] relative animate-fadeIn" ref={modalRef}>
                <button
                    className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
                    onClick={onClose}
                >
                    ×
                </button>
                <div className="text-center">
                    <FaCheckCircle size={48} className="text-green-500 mx-auto mb-4" />
                    <h2 className="text-xl font-bold mb-2">Code Copied!</h2>
                    {/* <div className="text-gray-600 break-all flex justify-center items-center text-center mx-auto w-10/12 sm:w-full">{gift_code}
                    </div> */}
                </div>
            </div>
        </div>
    );
};
